module.exports = __webpack_public_path__ + "landing_static/img/logo-white.15718064.svg";